module.exports = __webpack_public_path__ + "static/media/fbe-topographic-pattern-gold12.3bd34277.svg";